<template>
  <div>
    <div>
      <div class="a-tab__title-block">
        <h3>{{$t('form.lot.parts-and-payments')}}</h3>
      </div>
    </div>

    <div class="table-tab table-tab--th-row-none">
      <div class="admin-buy__block-gui-btn a-flex-start u-margin-b-24">
        <button class="gui-btn gui-btn--red u-margin-left-auto" type="button" @click.prevent="onDownloadPaymentsClick">
          {{$t('buttons.download-payments-table')}}
        </button>
        <file-picker :label="'buttons.upload-payments-table'"
                     accept="csv"
                     :signing="false"
                     @prepared="onFileSelected"
                     v-if="canEditRetend">
        </file-picker>
      </div>

      <base-payments-and-parts :parts="retend.parts"
                               :schedule="retend.schedule"
                               :can-edit-table="canEditRetend"
                               @update="onUpdate"/>
    </div>

    <div class="a-container-form admin-buy__block"
         :class="{
          'a-input-group--error': $v.retend.changeDescription.$error,
          'a-mandatory': retend.willBeSentForApproval
         }"
         v-if="canEditRetend && retend.willBeSentForApproval">
      <div class="a-label ">{{$t('form.lot.changes-description')}}</div>
      <div class="a-form-field a-width-100-percent">
        <textarea class="a-textarea a-textarea--w-max "
                  rows="2"
                  v-model="retend.changeDescription"
                  @change="saveForm()">
        </textarea>
        <span class="a-validation-error" v-if="!$v.retend.changeDescription.required">{{$t('validation-error.mandatory-field-short')}}</span>
      </div>
    </div>
    <div class="a-container-form admin-buy__block" v-else-if="retend.changeDescription">
      <div class="a-label ">{{$t('form.lot.changes-description')}}:</div>
      <span class="a-input a-input--disabled u-red-color">{{retend.changeDescription}}</span>
    </div>
  </div>
</template>

<script>
  import { requiredIf } from '@/validators'
  import CommonMixins from '../mixins/common'
  import PermissionsMixins from '../mixins/permissions'
  import _ from "lodash";
  import BasePaymentsAndParts from "../common/base-PaymentsAndParts";

  export default {
    components: {
      BasePaymentsAndParts
    },

    props: {
      retend: {
        type: Object,
        required: true
      },

      lot: {
        type: Object,
        required: true
      }
    },

    validations: {
      retend: {
        changeDescription: {
          required: requiredIf(model => model.willBeSentForApproval)
        }
      }
    },

    mixins: [
      CommonMixins,
      PermissionsMixins
    ],

    created() {
      this.$v.$touch();
    },

    methods: {
      async onDownloadPaymentsClick() {
        this.runAction(async () => {
          try {
            await this.$store.dispatch('exportBidPayments', {
              requestId: this.lot.request.id,
              bidId: this.bid.id,
              filename: `${this.lot.catalog.name}-${this.lot.request.id}-${this.bid.num}-payments`
            });
          }
          catch(e) {
            console.error('failed download of bid payments', e);
            this.globalErrorHandler(e);
          }
        });
      },

      async onFileSelected(file) {
        try {
          await this.$store.dispatch('uploadBidPayments', {
            lotId: this.lot.id,
            requestId: this.lot.request.id,
            bidId: this.bid.id,
            file
          });

          await this.saveForm();
        }
        catch(e) {
          console.error('failed upload of bid payments', e);
          this.globalErrorHandler(e);
        }
      },

      async onUpdate(parts) {
        this.retend.parts = parts;
        await this.saveForm();
      }
    }
  }
</script>

<style scoped>

</style>
